import { render } from "./QHumanKnowledgeandSkills.vue?vue&type=template&id=3dec4eef&ts=true"
import script from "./QHumanKnowledgeandSkills.vue?vue&type=script&lang=ts"
export * from "./QHumanKnowledgeandSkills.vue?vue&type=script&lang=ts"

import "./QHumanKnowledgeandSkills.vue?vue&type=style&index=0&id=3dec4eef&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__